<template>
  <div class="user user__menu">
    <div class="photo">
      <img :src="avatar" alt="avatar"/>
    </div>
    <div class="info">
      <a
          data-toggle="collapse"
          :aria-expanded="!isClosed"
          @click.stop="toggleMenu"
          href="#"
      >
        <span>
          {{ locale.profile }}
          <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav user-menu__nav" v-show="!isClosed">
            <slot>
              <li v-if="logged_user_role == 'App\\Models\\Provider'">
                <a href="/examples/user-profile">
                  <span class="sidebar-mini-icon">MP</span>
                  <span class="sidebar-normal">{{ locale.my_profile }}</span>
                </a>
              </li>

              <li>
                <a class="twhite" @click.prevent="logout()">
                  <span class="sidebar-mini-icon">L</span>
                  <span class="sidebar-normal">{{ locale.logout }}</span>
                </a>
              </li>

              <li v-if="logged_user_role == 'App\\Models\\ProviderWorker'">
                <a
                    @click="onChangePassword()">
                  <span class="sidebar-mini-icon">CP</span>
                  <span class="sidebar-normal">{{ locale.change_password }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </collapse-transition>
      </div>
    </div>
    <modal name="change-password-form"
           :adaptive="true" :resizable="true" :minHeight="150">
      <div style="margin: 1em; margin-top: 2em;">
        <n-button
            @click.native="onModalHide('change-password-form')"
            class="remove text-end close-modal-btn"
            type="danger"
            size="sm"
            round
            icon
        >
          <i class="fa fa-times"></i>
        </n-button>
        <div class="d-flex mx-3 flex-column">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column w-40">
              <span class="w-100">{{ locale.password }}:* </span>
              <input class="w-100" style="height: 2rem" v-model="password">
            </div>
            <div class="mb-3 d-flex flex-column w-40">
              <span class="w-100">{{ locale.password_confirmation }}:* </span>
              <input class="w-100" style="height: 2rem" v-model="password_confirmation">
            </div>
          </div>
          <p v-if="!checkRequires()">* {{ locale.fill_all_required_fields }}</p>
          <div style="text-align: center">
            <n-button v-if="checkRequires()"
                      type="primary"
                      class="btn btn-sm btn-primary"
                      @click.native="changePassword()"
            >
              <span >{{ locale.change_password }}</span>
            </n-button>
          </div>
      </div>
      </div>
    </modal>
  </div>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  name: "user-menu",
  components: {
    CollapseTransition,
  },

  async created() {
    this.avatar = "/img/avatar.png";
  //   return;
  //   this.$store.watch(
  //       () => this.$store.getters["profile/me"],
  //       (me) => {
  //         this.title = me.name;
  //         this.avatar = me.profile_image
  //             ? me.profile_image
  //             : "/img/placeholder.jpg";
  //       }
  //   );
  //   await this.$store.dispatch("profile/me");
  },
  data() {
    return {
      password: '',
      password_confirmation: '',
      isClosed: true,
      avatar: null,
      logged_user_role: '',
      locale: '',
      user_id: '',
    };
  },
  methods: {
    checkRequires() {
      return (this.password != '' && this.password_confirmation != '' && this.password == this.password_confirmation)
    },

    onModalHide(name) {
      this.$modal.hide(name);
    },
    onChangePassword() {
      this.password = '';
      this. password_confirmation = '';
      this.$modal.show('change-password-form');
    },

    async changePassword() {
      let user_data = {
        'password': this.password,
        'id': this.user_id,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/change-password", requestOptions)
          .then(response => alert('Password changed'));
      this.$modal.hide('change-password-form');
    },

    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },

  mounted() {
    this.locale = this.$getLocale();
    // POST request using fetch with error handling
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
        , 'Accept': 'application/json'
      },
      body: JSON.stringify({title: 'Vue POST Request Example'})
    };
    fetch(url + '/get-logged-role', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }

          this.user_id = data.id;
          this.logged_user_role = data.profile_type;
        })
        .catch(error => {
          this.errorMessage = error;
          console.error('There was an error!', error);
        });
  },

};
</script>
<style scoped>
.user__menu ul.user-menu__nav {
  margin-top: 0;
  padding-top: 20px;
}

a.twhite:hover {
  color: white !important;
}

.card-body .vm--container {
  z-index: 9999999;
}

.close-modal-btn {
  position: absolute;
  top: 0;
  right: 1%;
}

.w-40 {
  width: 44.5%;
}

input {
  border-radius: 8px;
  border: 1px solid grey;
  height: 2rem;
}
</style>
